<mat-chip-grid #chipList>
  @for (item of SelectedItems; track item) {
    <mat-chip
      (removed)="remove(item)">
      {{item.DisplayText}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  }

  <input matInput
    #multiInput
    autocomplete="off"
    name="trial_responsible-multi-{{id}}"
    [matAutocomplete]="ftmsAutocompleteMulti"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
    [formControl]="inputControl"
    (matChipInputTokenEnd)="add($event)"
    #autocompleteTrigger="matAutocompleteTrigger"
    autocompleteValidator />

</mat-chip-grid>

<mat-autocomplete #ftmsAutocompleteMulti="matAutocomplete" panelClass="standard-modal-panel"
  [displayWith]="DisplayItem"
  (optionSelected)="autocompleteSelect($event)"
  (opened)="autocompleteOpened()">
  @for (item of FilteredList | async; track item) {
    <mat-option [value]="item">
      {{item.DisplayText}}
    </mat-option>
  }
</mat-autocomplete>
